// Helper: produce a YYYY-MM-DD string relative to today
const today = new Date();
const addDays = (n) => {
  const d = new Date(today);
  d.setDate(d.getDate() + n);
  return d.toISOString().split("T")[0];
};

export const TODAY_STR = addDays(0);

export const downloadInvoice = (url) => {
  const link = document.createElement("a");

  const fileName = url.split("/").pop().split("?")[0];

  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
